import React from 'react';
import { Container } from '@mui/material';
import Header from './components/Header';
import BannerCarousel from './components/BannerCarousel';
//import Section from './components/Section';
import Player from './components/Player';
import Post from './components/Post';
import StaticHtml from './components/StaticHtml';

function NewApp() {
  return (
    <>
      <Header />
      <Container 
        maxWidth='lg'
        // sx={{ padding: 0, margin: 0, }}
        >
        
        {/* <BannerCarousel /> */}
        {/* <Section title="추천 에피소드" items={[1, 2, 3, 4]} />
        <Section title="LIVE 채널" items={[5, 6, 7, 8]} /> */}
        <Post />
        {/* <StaticHtml number={1} /> */}
      </Container>
      {/* <Player /> */}
    </>
  );
}

export default NewApp;